import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import '@adornis/popover/x-tooltip.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { property } from 'lit/decorators/property.js';

@customElement('ils-product-card')
export class ILSProductCard extends ChemistryLitElement {
  override styles() {
    return [
      {
        '[button]': {
          background: this.colors.accent,
          color: this.colors.on.accent,
          margin: `0 -${this.spacing.md}`,
          transition: 'color .12s, background-color .12s',
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            background: this.colors.tone.active,
            color: this.colors.on.tone.active,
          },
        },
        ':host([disabled]) [button]': {
          background: this.colors.neutral.shade(200),
          pointerEvents: 'none',
        },
        ':host([cover]) x-card': { width: '100%', height: '100%' },
        'x-basic-card': {
          width: 'unset',
          transition: 'all 0.3s ease',
          padding: this.spacing.md,
          paddingBottom: '0',
          '&:hover': {
            boxShadow: '0 0 5px 2px rgba(0,0,0,.2)',
            transform: 'translateY(-3px) scale(1.02)',
          },
        },
        'x-icon': {
          fontVariationSettings: "'FILL' 0,'wght' 400,'GRAD' 0,'opsz' 20",
        },
      },
    ];
  }
  @property() cardtitle: Renderable = '';
  @property() subtitle: Renderable = '';
  @property() description: Renderable = '';
  @property() infoText: Renderable = '';
  @property({ attribute: false }) buttonText: Renderable = '';

  @property({ type: Boolean }) disabled = false;

  override render() {
    return html`
      <x-basic-card>
        <x-flex ${css({ height: '100%' })}> ${this._renderProductDetails()} ${this._renderPrimaryButton()} </x-flex>
      </x-basic-card>
    `;
  }

  private _renderProductDetails(): Renderable {
    return html`
      <x-flex
        flex
        space="md"
        ${css({ paddingBottom: this.spacing.md })}
        @click=${() => {
          if (this.disabled) return;
          this.dispatchEvent(new CustomEvent('button-click', { bubbles: true, composed: true, cancelable: true }));
        }}
      >
        <x-flex horizontal space-between crossaxis-center>
          <x-h3> ${this.cardtitle} </x-h3>
        </x-flex>
        ${this.subtitle ? html`<x-text> ${this.subtitle} </x-text>` : nothing}
        ${this.description ? html`<x-text> ${this.description} </x-text>` : nothing}
      </x-flex>
    `;
  }

  private _renderPrimaryButton(): Renderable {
    return html`
      <x-flex
        button
        crossaxis-center
        center
        padding="md"
        @click=${(e: MouseEvent) => {
          e.stopPropagation();
          if (this.disabled) return;
          this.dispatchEvent(new CustomEvent('button-click', { bubbles: true, composed: true, cancelable: true }));
        }}
      >
        <x-h4> ${this.buttonText} </x-h4>
      </x-flex>
    `;
  }
}
